import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePusher } from 'contexts/PusherProvider';
import { RootState } from 'redux/store';
import {
  addNotification,
  fetchNotifications,
} from '../../redux/slices/notification';
import { notificationChannelName } from 'utils/pusher';

/**
 * Subscribes once per authenticated session (shell-level).
 * Must not live inside NotificationCard/Navbar — those remount per route
 * and can stack duplicate Pusher handlers.
 */
const NotificationRealtimeListener = () => {
  const dispatch = useDispatch();
  const pusher = usePusher();
  const user = useSelector((state: RootState) => state.user.user);

  useEffect(() => {
    fetchNotifications();
  }, []);

  useEffect(() => {
    if (!pusher || !user?.id) {
      return undefined;
    }

    const channelName = notificationChannelName(user.id);
    const channel = pusher.subscribe(channelName);

    const onEvent = (eventName: string, data: unknown) => {
      if (eventName.startsWith('pusher:')) return;
      dispatch(addNotification(data));
    };

    channel.bind_global(onEvent);

    return () => {
      channel.unbind_global(onEvent);
      pusher.unsubscribe(channelName);
    };
  }, [pusher, user?.id, dispatch]);

  return null;
};

export default NotificationRealtimeListener;
